import { Reveal, Eyebrow } from "./Reveal";

const Highlight = ({ children }) => (
  <span className="text-[#111827] font-medium border-b border-[#7F9F43]/40 pb-0.5">{children}</span>
);

export default function Assistance() {
  return (
    <section className="py-24 lg:py-32" data-testid="assistance-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Reveal>
              <Eyebrow number="06" label="Intelligent Assistance" />
              <h2 className="text-3xl sm:text-4xl font-light tracking-tight text-[#111827]">
                One seamless <span className="font-serif-italic text-[#E89A4D]">companion.</span>
              </h2>
              <div className="mt-10 rounded-3xl overflow-hidden card-soft hidden lg:block">
                <img
                  src="/assets/garden-walk.jpg"
                  alt="An elderly couple walking through a sunlit garden"
                  className="w-full h-72 object-cover hover:scale-[1.03] transition-transform duration-700"
                />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:col-start-6">
            <Reveal delay={0.1}>
              <div className="space-y-7 text-lg md:text-xl font-light leading-relaxed text-gray-600">
                <p>
                  Romii brings together multiple intelligent technologies into one seamless
                  wearable experience — designed to feel less like a device, and more like a
                  trusted presence.
                </p>
                <p>
                  Through <Highlight>voice-first interaction</Highlight> and{" "}
                  <Highlight>context-aware conversations</Highlight>, Romii speaks naturally and
                  understands the moment. It offers <Highlight>personalized reminders</Highlight>{" "}
                  and gentle <Highlight>memory assistance</Highlight>, helping the day flow with
                  confidence rather than confusion.
                </p>
                <p>
                  When it matters most, Romii quietly watches over its wearer — aware of{" "}
                  <Highlight>distress and falls</Highlight>, ready with{" "}
                  <Highlight>emergency assistance</Highlight>, and connected to loved ones through{" "}
                  <Highlight>GPS and Safe Zone support</Highlight> and{" "}
                  <Highlight>secure communication</Highlight>.
                </p>
                <p>
                  And because every person's journey is different, Romii keeps getting better —
                  with <Highlight>AI-powered contextual responses</Highlight>,{" "}
                  <Highlight>continuous software improvements</Highlight>,{" "}
                  <Highlight>multi-language support</Highlight>, and a{" "}
                  <Highlight>comfortable wearable design</Highlight> made for all-day reassurance.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
